<template>
  <nav-header :title="title"></nav-header>
  <main class="settings-page">
    <div class="container settings-container">
      <div
        v-if="couldNotUpdateRankingSetting"
        class="alert alert-warning settings-alert"
        role="alert"
      >
        <i class="material-icons" aria-hidden="true">cloud_off</i>
        <span>
          Kunne ikke opdatere indstilling for visning på rangliste - måske er
          du offline?
        </span>
      </div>

      <div class="settings-grid">
        <section class="settings-card settings-card-wide">
          <div class="settings-card-heading">
            <span class="settings-card-icon" aria-hidden="true">
              <i class="material-icons">emoji_events</i>
            </span>
            <h2>{{ $englishPreferred ? "Game mode" : "Spiltilstand" }}</h2>
          </div>

          <div class="settings-list">
            <div class="setting-row">
              <label for="rankingActiveSwitch">
                {{
                  $englishPreferred
                    ? "Show me on rankings"
                    : "Vis mig på ranglister"
                }}
              </label>
              <input
                id="rankingActiveSwitch"
                v-model="rankingActive"
                class="form-check-input settings-switch"
                type="checkbox"
                role="switch"
                @change="rankingActivityToggle()"
              />
            </div>
            <div class="setting-row">
              <label for="seePointsSwitch">
                {{
                  $englishPreferred
                    ? "Show points on my personal statistics"
                    : "Vis point på min personlige statistikside"
                }}
              </label>
              <input
                id="seePointsSwitch"
                v-model="seePoints"
                class="form-check-input settings-switch"
                type="checkbox"
                role="switch"
                @change="checkPoints($event)"
              />
            </div>
          </div>
        </section>

        <section class="settings-card">
          <div class="settings-card-heading">
            <span class="settings-card-icon" aria-hidden="true">
              <i class="material-icons">translate</i>
            </span>
            <h2>{{ $englishPreferred ? "Language" : "Sprog" }}</h2>
          </div>
          <p class="settings-description">
            {{
              $englishPreferred
                ? "Here you may switch between Danish and English as language"
                : "Her kan du skifte mellem dansk eller engelsk sprog i appen"
            }}.
          </p>

          <div class="choice-grid">
            <label
              class="choice-option"
              :class="{ 'is-selected': englishPreferred === false }"
              for="danishRadio"
            >
              <input
                id="danishRadio"
                v-model="englishPreferred"
                type="radio"
                :value="false"
                name="languageOptions"
                @change="switchToEnglish(false)"
              />
              <span>{{ $englishPreferred ? "Danish" : "Dansk" }}</span>
            </label>
            <label
              class="choice-option"
              :class="{ 'is-selected': englishPreferred === true }"
              for="englishRadio"
            >
              <input
                id="englishRadio"
                v-model="englishPreferred"
                type="radio"
                :value="true"
                name="languageOptions"
                @change="switchToEnglish(true)"
              />
              <span>{{ $englishPreferred ? "English" : "Engelsk" }}</span>
            </label>
          </div>
        </section>

        <section class="settings-card">
          <div class="settings-card-heading">
            <span class="settings-card-icon" aria-hidden="true">
              <i class="material-icons">layers</i>
            </span>
            <h2>{{ $englishPreferred ? "Map background" : "Kortbaggrund" }}</h2>
          </div>
          <p class="settings-description">
            {{
              $englishPreferred
                ? "Here you may switch the default map background"
                : "Her kan du skifte den standard kortbaggrund"
            }}.
          </p>

          <div class="choice-grid">
            <label
              class="choice-option"
              :class="{ 'is-selected': ortoPreferred === false }"
              for="openStreetMap"
            >
              <input
                id="openStreetMap"
                v-model="ortoPreferred"
                type="radio"
                :value="false"
                name="mapOptions"
                @change="switchToOrto(false)"
              />
              <span>OpenStreetMap</span>
            </label>
            <label
              class="choice-option"
              :class="{ 'is-selected': ortoPreferred === true }"
              for="ortofotoMap"
            >
              <input
                id="ortofotoMap"
                v-model="ortoPreferred"
                type="radio"
                :value="true"
                name="mapOptions"
                @change="switchToOrto(true)"
              />
              <span>Ortofoto</span>
            </label>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import NavHeader from "@/components/navbars/NavHeader.vue";
import axios from "axios";

export default {
  components: {
    NavHeader,
  },
  data() {
    return {
      title: this.$englishPreferred ? "Settings" : "Indstillinger",
      seePoints: true,
      ortoPreferred: false,
      englishPreferred: false,
      rankingActive: true,
      couldNotUpdateRankingSetting: false,
    };
  },
  methods: {
    checkPoints: function (e) {
      let value = this.seePoints ? true : false;
      $cookies.set("seePoints", value, 60 * 60 * 24 * 365 * 10);
    },
    switchToEnglish(booleanValue) {
      if (booleanValue == true) {
        $cookies.set("englishPreferred", 60 * 60 * 24 * 365 * 10);
      } else {
        $cookies.remove("englishPreferred");
      }
      window.location.reload();
    },
    switchToOrto(booleanValue) {
      if (booleanValue == true) {
        $cookies.set("ortoPreferred", 60 * 60 * 24 * 365 * 10);
      } else {
        $cookies.remove("ortoPreferred");
      }
    },
    async rankingActivityToggle() {
      let isOptingOut = this.rankingActive ? false : true;
      if (isOptingOut == true) {
        axios
          .get("/spontan/ranking/optout")
          .then((response) => {
            $cookies.set("rankingInactive", "true", "10y");
            this.couldNotUpdateRankingSetting = false;
          })
          .catch((error) => {
            this.rankingActive = true;
            this.couldNotUpdateRankingSetting = true;
          });
      } else {
        axios
          .get("/spontan/ranking/optin")
          .then((response) => {
            $cookies.remove("rankingInactive");
            this.couldNotUpdateRankingSetting = false;
          })
          .catch((error) => {
            this.rankingActive = false;
            this.couldNotUpdateRankingSetting = true;
          });
      }
    },
  },
  mounted() {
    if ($cookies.isKey("seePoints")) {
      this.seePoints = $cookies.get("seePoints");
    }
    if ($cookies.isKey("ortoPreferred")) {
      this.ortoPreferred = true;
    }
    if ($cookies.isKey("englishPreferred")) {
      this.englishPreferred = true;
    }
    if ($cookies.isKey("rankingInactive")) {
      this.rankingActive = false;
    }
  },
};
</script>

<style scoped>
:deep(#navbar) {
  margin-bottom: 0 !important;
}

.settings-page {
  background:
    radial-gradient(circle at 8% 0%, rgb(31 122 175 / 10%), transparent 24rem),
    radial-gradient(circle at 94% 12%, rgb(81 175 48 / 9%), transparent 22rem),
    #f5f8f9;
  min-height: calc(100vh - 8rem);
  padding: 1.5rem 0 3rem;
}

.settings-container {
  max-width: 940px;
}

.settings-alert {
  align-items: center;
  border: 0;
  border-radius: 1rem;
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.settings-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.settings-card {
  background: #fff;
  border: 1px solid rgb(31 122 175 / 11%);
  border-radius: 1.15rem;
  box-shadow: 0 7px 24px rgb(35 77 98 / 9%);
  padding: 1.25rem;
}

.settings-card-wide {
  grid-column: 1 / -1;
}

.settings-card-heading {
  align-items: center;
  display: flex;
  gap: 0.8rem;
  margin-bottom: 1rem;
}

.settings-card-icon {
  align-items: center;
  background: linear-gradient(135deg, rgb(31 122 175 / 14%), rgb(81 175 48 / 15%));
  border-radius: 0.75rem;
  color: #247e8c;
  display: flex;
  flex: 0 0 auto;
  height: 2.6rem;
  justify-content: center;
  width: 2.6rem;
}

.settings-card-icon .material-icons {
  font-size: 1.35rem;
}

.settings-card h2 {
  color: #174f70;
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0;
}

.settings-list {
  background: #f7fafb;
  border: 1px solid rgb(31 122 175 / 9%);
  border-radius: 0.9rem;
  overflow: hidden;
}

.setting-row {
  align-items: center;
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr) auto;
  min-height: 3.8rem;
  padding: 0.75rem 1rem;
}

.setting-row + .setting-row {
  border-top: 1px solid rgb(31 122 175 / 10%);
}

.setting-row label {
  color: #344953;
  cursor: pointer;
  line-height: 1.35;
}

.settings-switch {
  cursor: pointer;
  float: none;
  height: 1.55rem;
  margin: 0;
  width: 2.85rem;
}

.settings-switch:checked {
  background-color: #51af30;
  border-color: #51af30;
}

.settings-description {
  color: #667781;
  font-size: 0.9rem;
  line-height: 1.55;
  margin: -0.25rem 0 1rem;
}

.choice-grid {
  display: grid;
  gap: 0.65rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.choice-option {
  align-items: center;
  background: #f7fafb;
  border: 1px solid rgb(31 122 175 / 16%);
  border-radius: 0.8rem;
  color: #435762;
  cursor: pointer;
  display: flex;
  font-size: 0.92rem;
  font-weight: 600;
  gap: 0.55rem;
  min-height: 3.2rem;
  padding: 0.65rem 0.8rem;
  transition:
    background-color 150ms ease,
    border-color 150ms ease,
    box-shadow 150ms ease;
}

.choice-option:hover {
  border-color: rgb(31 122 175 / 42%);
}

.choice-option:focus-within {
  box-shadow: 0 0 0 0.2rem rgb(31 122 175 / 16%);
}

.choice-option.is-selected {
  background: rgb(31 122 175 / 9%);
  border-color: #1f7aaf;
  color: #17648f;
}

.choice-option input {
  accent-color: #1f7aaf;
  flex: 0 0 auto;
  height: 1.05rem;
  margin: 0;
  width: 1.05rem;
}

.choice-option span {
  min-width: 0;
  overflow-wrap: anywhere;
}

@media (max-width: 720px) {
  .settings-grid {
    grid-template-columns: 1fr;
  }

  .settings-card-wide {
    grid-column: auto;
  }
}

@media (max-width: 420px) {
  .settings-page {
    padding: 1rem 0 2rem;
  }

  .settings-card {
    padding: 1rem;
  }

  .choice-grid {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .choice-option {
    transition: none;
  }
}
</style>
